<script lang="ts">
  import { defineComponent } from "vue";
  import SectionContratTemplateConfig from '@/generated/sections/SectionContratTemplateConfig.vue';
  export default defineComponent({
    extends: SectionContratTemplateConfig,
    components: {},
    methods: {
      isDisplayed(value: string): boolean {
        if (value == 'ACTIVE') {
          return true;
        }
        return (SectionContratTemplateConfig as any).methods.isDisplayed.call(this, value);
      },
      isRequired(value: string): boolean {
        if (value == 'ACTIVE') {
          return false;
        }
        return (SectionContratTemplateConfig as any).methods.isRequired.call(this, value);
      }
    }
  })
</script>
